import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=0f6a8b76&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"
import style0 from "./Terms.vue?vue&type=style&index=0&id=0f6a8b76&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6a8b76",
  null
  
)

export default component.exports